import { closeAssignment as closeAssignmentApi } from '../api';
import { CLOSE_ASSIGNMENT } from '../actions';
import { accessToken as getAccessToken } from '../../selectors/user';

import { analyticsTrackEvent } from '../../utils/analytics';
import * as analyticEvents from '../../constants/analytics';

const closeAssignmentDispatch = ({ dispatch, status, payload }) =>
  dispatch({
    type: CLOSE_ASSIGNMENT,
    status,
    payload,
  });

const closeAssignment =
  ({ spaceId, assignment }) =>
  async (dispatch, getState) => {
    closeAssignmentDispatch({
      dispatch,
      status: 'started',
      payload: { assignment },
    });

    const state = getState();
    const accessToken = getAccessToken(state, spaceId);

    if (!accessToken) {
      closeAssignmentDispatch({
        dispatch,
        payload: { spaceId },
        status: 'error',
      });

      return null;
    }

    try {
      const { data } = await closeAssignmentApi({
        accessToken,
        spaceId,
        assignment,
      });

      if (!data || !data.assignment) {
        throw new Error('fail to close assignment');
      }

      const updatedAssignment = data.assignment;

      analyticsTrackEvent(analyticEvents.CLOSE_ASSIGNMENT, {
        assignment: updatedAssignment,
        activeClassroom: spaceId,
      });

      closeAssignmentDispatch({
        dispatch,
        status: 'success',
        payload: {
          spaceId,
          assignment: updatedAssignment,
        },
      });

      return updatedAssignment;
    } catch (e) {
      closeAssignmentDispatch({
        dispatch,
        payload: { spaceId },
        status: 'error',
      });

      return null;
    }
  };

export default closeAssignment;
